import { publicClient, privateClient } from "../../configs/axiosConfig";

const serviceEndpoints = {
  getallNail: "v2/nails",
  getallNailPublic: `v2/nails/getpublicnail?key=${process.env.REACT_APP_REMINDER_CRON_SECRET}`,
  getNailDetail: "v2/nails/:id",
  getallBeauty: "v2/beauty",
  getallBeautyPublic: `v2/beauty/getpublicbeauty?key=${process.env.REACT_APP_REMINDER_CRON_SECRET}`,
  getBeautyDetail: "v2/beauty/:id",
};

const sericesApi = {
  getallNail: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallNail}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getallNailPublic: async () => {
    try {
      const response = await publicClient.get(
        serviceEndpoints.getallNailPublic
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getNailDetail: async ({ nailId }) => {
    try {
      const response = await privateClient.get(serviceEndpoints.getNailDetail, {
        nailId,
      });

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getallBeauty: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallBeauty}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getallBeautyPublic: async () => {
    try {
      const response = await publicClient.get(
        serviceEndpoints.getallBeautyPublic
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getBeautyDetail: async ({ beatyId }) => {
    try {
      const response = await privateClient.get(
        serviceEndpoints.getBeautyDetail,
        {
          beatyId,
        }
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
};

export default sericesApi;
